import React, { MouseEventHandler } from 'react';

import { ReactComponentLike } from 'prop-types';
import { Link, useRouteMatch } from 'react-router-dom';

import { externalLink, localizeUrl } from 'helpers/locales';

interface IProps {
  activeClassName?: string;
  children?: React.ReactNode;
  className?: string;
  Component?: ReactComponentLike;
  'data-testid'?: string;
  id?: string;
  isActive?: (match, location) => boolean;
  onClick?: MouseEventHandler;
  role?: React.AriaRole;
  style?: React.CSSProperties;
  target?: string;
  to: string;
}

export const NestedLink = ({
  to,
  Component = Link,
  children,
  ...props
}: IProps) => {
  const match = useRouteMatch();

  if (externalLink(to))
    return (
      <a
        className={props.className}
        data-testid={props['data-testid']}
        href={to}
        id={props.id}
        onClick={props.onClick}
        role={props.role}
        style={props.style}
        target={props.target}
      >
        {children}
      </a>
    );

  const nestedTo = localizeUrl(match.url, to);

  return (
    <Component to={nestedTo} {...props}>
      {children}
    </Component>
  );
};

export default NestedLink;
